// removed by extract-text-webpack-plugin
module.exports = {"Modal":"_2H_9Ag36-MoOojn4AO3Atr","NoOnlineEmployees":"_26yWUJjNvkmYhL--9ooNKh","Item":"_294XZtR2lPqqn2Eu0ly0Ei","ImgContainer":"_3T34FnckT0qJ3g8hX61XXf","Online":"_1wKSEvOJbIDNDsyvW7RMw1","Offline":"_31jUkkzvVWehpZb6vrQv2A"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Modal/Transfer/style.css
// module id = 946
// module chunks = 0